import { colorPalette, grayBackground } from 'styles/css-constants';
import { MQ_MEDIUM, MQ_SMALL_ONLY } from 'constants/mq';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import css from 'styled-jsx/css';

export default css`
  .UserCompleteSignup {
  }

  .UserCompleteSignup h1 {
    color: ${sharedPalette.watermelon};
  }

  .UserCompleteSignup .card {
    background-color: ${grayBackground};
  }

  .UserCompleteSignup p {
    margin: 1rem 0;
    line-height: 1.5em;
  }

  .UserCompleteSignup__error {
    color: red;
    font-size: var(--fontScaleNeg1);
    margin-top: 0.5em;
  }

  .UserCompleteSignup__input {
    background-color: ${warmGrays[0]};
    border: 0;
    font-size: var(--baseFontScale);
    outline: 0;
    padding: 0.5rem;
    width: 100%;
  }

  .UserCompleteSignup button {
    background: ${sharedPalette.watermelon};
    border: none;
    color: ${colorPalette.white};
    display: block;
    font-size: 1rem;
    padding: 0.5em;
  }

  @media ${MQ_SMALL_ONLY} {
    .UserCompleteSignup {
      margin: 1rem;
    }

    .UserCompleteSignup .card {
      padding: 1.5rem;
    }

    .UserCompleteSignup button {
      margin-top: 1.5rem;
      width: 100%;
    }
  }

  @media ${MQ_MEDIUM} {
    .UserCompleteSignup {
      margin: 3rem auto;
      width: 640px;
    }

    .UserCompleteSignup .card {
      padding: 2rem;
      margin-top: 2rem;
    }

    .UserCompleteSignup button {
      margin-top: 2rem;
      padding-left: 5rem;
      padding-right: 5rem;
    }
  }
`;
